"use client";

import { createContext, useContext, type ReactNode } from "react";

export type LocalizedPaths = Partial<Record<string, string>>;

const LocalizedPathsContext = createContext<LocalizedPaths | null>(null);

export function LocalizedPathsProvider({
      paths,
      children,
}: {
      paths: LocalizedPaths;
      children: ReactNode;
}) {
      return (
            <LocalizedPathsContext.Provider value={paths}>
                  {children}
            </LocalizedPathsContext.Provider>
      );
}

export function useLocalizedPaths(): LocalizedPaths | null {
      return useContext(LocalizedPathsContext);
}
